import { Box, styled } from "@mui/material";

export const StyledQuoteItemsCard = styled(Box)(({ theme }) => ({
  minHeight: "2rem",
  width: "100%",
  display: "flex",
  borderBottom: `2px solid ${theme.color.dark}`,
  alignItems: "center",
  h4: {},
  ".position": {
    width: "5%",
    paddingInline: ".5rem",
  },
  ".description": {
    width: "80%",
    maxWidth: "85%",
    textWrap: "wrap",
    borderLeft: `2px solid ${theme.color.dark}`,
    borderRight: `2px solid ${theme.color.dark}`,
    paddingInline: ".5rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    h4: {
      maxWidth: "90%",
      textWrap: "wrap",
    },
    ".actions": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      svg: {
        cursor: "pointer",
        color: theme.color.dark,
        "&:hover": {
          color: theme.color.main,
        },
      },
    },
  },
  ".total": {
    width: "15%",
    display: "flex",
    paddingInline: ".5rem",
    justifyContent: "space-between",
  },
  ".actions": {
    width: "10%",
  },
}));
